import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Bot, MessageSquare, Plug, CreditCard, LogOut, Menu, X, Inbox, Image as ImageIcon, Wifi, MessagesSquare, ClipboardList, Mail, Send, Briefcase , AlertTriangle } from 'lucide-react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Funcionarios from './pages/Funcionarios';
import Conversas from './pages/Conversas';
import Integracoes from './pages/Integracoes';
import Formularios from './pages/Formularios';
import EmailRegras from './pages/EmailRegras';
import Billing from './pages/Billing';
import Atendimentos from './pages/Atendimentos';
import Leads from './pages/Leads';
import OrdensSecretaria from './pages/OrdensSecretaria';
import PainelAdmin from './pages/PainelAdmin';
import Midias from './pages/Midias';
import Isps from './pages/Isps';
import Servicos from './pages/Servicos';
import Erros from './pages/Erros';

function SynapseLogo({ size = 32 }) {
    return <img src="/synapse-logo.svg" alt="Synapse" style={{ width: size, height: size }} />;
}

function Sidebar({ collapsed, setCollapsed }) {
    const navigate = useNavigate();
    const logout = () => { localStorage.removeItem('synapse_token'); navigate('/login'); };
    const links = [
        { to:'/dashboard', icon:LayoutDashboard, label:'Dashboard' },
        { to:'/clientes', icon:Users, label:'Clientes' },
        { to:'/funcionarios', icon:Bot, label:'Funcionarios' },
        { to:'/conversas', icon:MessageSquare, label:'Conversas' },
        { to:'/integracoes', icon:Plug, label:'Integracoes' },
        { to:'/formularios', icon:ClipboardList, label:'Formularios' },
        { to:'/email-regras', icon:Mail, label:'E-mails' },
        { to:'/isps', icon:Wifi, label:'ISPs' },
        { to:'/ordens-secretaria', icon:Inbox, label:'Ordens Secretaria' },
        { to:'/midias', icon:ImageIcon, label:'Midias' },
        { to:'/billing', icon:CreditCard, label:'Cobrança' },
        { to:'/servicos', icon:Briefcase, label:'Servicos' },
        { to:'/atendimentos', icon:MessagesSquare, label:'Atendimentos' },
        { to:'/leads', icon:Send, label:'Leads enviados' },
        { to:'/erros', icon:AlertTriangle, label:'Erros' },
        { to:'/mytime', icon:Users, label:'MyTime' },
    ];
    return (
        <div style={{ width:collapsed?68:240, minHeight:'100vh', background:'var(--bg-secondary)', borderRight:'1px solid var(--border)', display:'flex', flexDirection:'column', transition:'width 0.3s', position:'fixed', left:0, top:0, bottom:0, zIndex:100 }}>
            <div style={{ padding:collapsed?'20px 0':'20px 20px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:collapsed?'center':'space-between' }}>
                {!collapsed ? (
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <SynapseLogo size={28} />
                        <span style={{ fontFamily:"'Space Grotesk', sans-serif", fontSize:18, fontWeight:600, letterSpacing:2 }}>SYNAPSE</span>
                    </div>
                ) : (
                    <SynapseLogo size={24} />
                )}
                <button onClick={()=>setCollapsed(!collapsed)} style={{ background:'none', border:'none', color:'var(--text-secondary)', cursor:'pointer', padding:4 }}>{collapsed?<Menu size={20}/>:<X size={18}/>}</button>
            </div>
            <nav style={{ flex:1, padding:'12px 0' }}>
                {links.map(link => (
                    <NavLink key={link.to} to={link.to} style={({isActive}) => ({ display:'flex', alignItems:'center', gap:12, padding:collapsed?'12px 0':'12px 20px', justifyContent:collapsed?'center':'flex-start', color:isActive?'var(--purple-400)':'var(--text-secondary)', textDecoration:'none', fontSize:14, fontWeight:isActive?500:400, borderLeft:isActive?'3px solid var(--purple-500)':'3px solid transparent', background:isActive?'rgba(127,119,221,0.08)':'transparent', transition:'all 0.2s' })}>
                        <link.icon size={20}/>{!collapsed && link.label}
                    </NavLink>
                ))}
            </nav>
            <div style={{ padding:collapsed?'16px 0':'16px 20px', borderTop:'1px solid var(--border)' }}>
                <button onClick={logout} style={{ display:'flex', alignItems:'center', gap:10, background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer', fontSize:13, padding:0, width:'100%', justifyContent:collapsed?'center':'flex-start' }}><LogOut size={18}/>{!collapsed && 'Sair'}</button>
            </div>
        </div>
    );
}

function Layout({ children }) {
    const [collapsed, setCollapsed] = useState(false);
    return (
        <div style={{ display:'flex' }}>
            <Sidebar collapsed={collapsed} setCollapsed={setCollapsed}/>
            <div style={{ marginLeft:collapsed?68:240, width:'100%', minHeight:'100vh', padding:'32px 40px', transition:'margin-left 0.3s' }}>{children}</div>
        </div>
    );
}

function PrivateRoute({ children }) {
    const token = localStorage.getItem('synapse_token');
    return token ? <Layout>{children}</Layout> : <Navigate to="/login"/>;
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login/>}/>
                <Route path="/dashboard" element={<PrivateRoute><Dashboard/></PrivateRoute>}/>
                <Route path="/clientes" element={<PrivateRoute><Clientes/></PrivateRoute>}/>
                <Route path="/funcionarios" element={<PrivateRoute><Funcionarios/></PrivateRoute>}/>
                <Route path="/conversas" element={<PrivateRoute><Conversas/></PrivateRoute>}/>
                <Route path="/integracoes" element={<PrivateRoute><Integracoes/></PrivateRoute>}/>
                <Route path="/formularios" element={<PrivateRoute><Formularios/></PrivateRoute>}/>
                <Route path="/email-regras" element={<PrivateRoute><EmailRegras/></PrivateRoute>}/>
                <Route path="/isps" element={<PrivateRoute><Isps/></PrivateRoute>}/>
                <Route path="/ordens-secretaria" element={<PrivateRoute><OrdensSecretaria/></PrivateRoute>}/>
                <Route path="/midias" element={<PrivateRoute><Midias/></PrivateRoute>}/>
                <Route path="/mytime" element={<PrivateRoute><PainelAdmin/></PrivateRoute>}/>
                <Route path="/billing" element={<PrivateRoute><Billing/></PrivateRoute>}/>
                <Route path="/servicos" element={<PrivateRoute><Servicos/></PrivateRoute>}/>
                <Route path="/atendimentos" element={<PrivateRoute><Atendimentos/></PrivateRoute>}/>
                <Route path="/leads" element={<PrivateRoute><Leads/></PrivateRoute>}/>
                <Route path="/erros" element={<PrivateRoute><Erros/></PrivateRoute>}/>
                <Route path="*" element={<Navigate to="/dashboard"/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
